<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['view_hr']==1">  

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="mb-2 float-end">
              <b-button v-b-modal.new-allowance size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Staff Allowance</b-button>
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
              <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(staffmember)="data">
                {{ data.item.staffmember.full_name }} <br>
                <small><b>{{ data.item.staffmember.contact }}</b></small>
              </template>
              <template #cell(month)="data">
                <span v-show="data.item.month == 1">January</span> <span v-show="data.item.month == 2">February</span>
                <span v-show="data.item.month == 3">March</span> <span v-show="data.item.month == 4">April</span>
                <span v-show="data.item.month == 5">May</span> <span v-show="data.item.month == 6">June</span>
                <span v-show="data.item.month == 7">July</span> <span v-show="data.item.month == 8">August</span>
                <span v-show="data.item.month == 9">September</span> <span v-show="data.item.month == 10">October</span>
                <span v-show="data.item.month == 11">November</span> <span v-show="data.item.month == 12">December</span>
              </template>
              <template #cell(actions)="data">
                <div class="btn-group">
                <b-button @click="edit(data.item.id,data.item.staffmember.id,data.item.amount,data.item.month,data.item.year,data.item.reason)" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                <b-button @click="remove(data.item.id,data.item.staffmember.full_name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                </div>
              </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <b>Total Allowances : {{ commas(totalallowances) }}</b>
              </div>
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="new-allowance" centered title="New Staff Allowance" title-class="font-18" hide-footer>
        <form @submit.prevent="addAllowance">
          <div class="form-group mb-2">
            <label>Staff Member</label>
            <b-form-select v-model="staffmemberid" :options="staffmembers" class="mb-3 form-control" value-field="id" text-field="full_name"></b-form-select>
            </div>
            <div class="form-group mb-2">
            <label>Amount</label>
            <input v-model="amount" type="number" class="form-control" />
            </div>
            <div class="form-group mb-2">
            <label>Month</label>
            <select class="form-control" v-model="month">
              <option value="1">January</option><option value="2">Febraury</option>
              <option value="3">March</option><option value="4">April</option>
              <option value="5">May</option><option value="6">June</option>
              <option value="7">July</option><option value="8">August</option>
              <option value="9">September</option><option value="10">October</option>
              <option value="11">November</option><option value="12">December</option>
            </select>
            </div>
            <div class="form-group mb-2">
            <label>Year</label>
            <b-form-select v-model="year" :options="years" class="mb-3 form-control"></b-form-select>
            </div>
            <div class="form-group mb-2">
            <label>Reason</label> 
            <textarea v-model="reason" rows="2" class="form-control"></textarea>
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-allowance')" >Close</b-button>
                <b-button type="submit" :disabled="btnuser" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="edit-allowance" centered title="Edit Staff Allowance" title-class="font-14" hide-footer>
        <form @submit.prevent="editAllowance">
            <div class="form-group mb-2">
            <input v-model="id" type="hidden">
            <label>Staff Member</label>
            <b-form-select v-model="staffmemberid" :options="staffmembers" class="mb-3 form-control" value-field="id" text-field="full_name"></b-form-select>
            </div>
            <div class="form-group mb-2">
            <label>Amount</label>
            <input v-model="amount" type="number" class="form-control" />
            </div>
            <div class="form-group mb-2">
            <label>Month</label>
            <select class="form-control" v-model="month">
              <option value="1">January</option><option value="2">Febraury</option>
              <option value="3">March</option><option value="4">April</option>
              <option value="5">May</option><option value="6">June</option>
              <option value="7">July</option><option value="8">August</option>
              <option value="9">September</option><option value="10">October</option>
              <option value="11">November</option><option value="12">December</option>
            </select>
            </div>
            <div class="form-group mb-2">
            <label>Year</label>
            <b-form-select v-model="year" :options="years" class="mb-3 form-control"></b-form-select>
            </div>
            <div class="form-group mb-2">
            <label>Reason</label> 
            <textarea v-model="reason" rows="2" class="form-control"></textarea>
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-allowance')" >Close</b-button>
                <b-button type="submit" :disabled="btnuser" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="delete-allowance" centered title="Delete Staff Allowance" title-class="font-18" hide-footer>
        <form @submit.prevent="removeAllowance">
            <input v-model="id" type="hidden">
              Are you sure you want to delete the Allowance : <b>{{ fullname }}</b> ?
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-allowance')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>
  </div>  
  <div v-else>
    <div class="row justify-content-center">
      <div class="col-md-8 col-xl-6">
        <div>
          <center><span class="text-primary h4">You have no permission to view the Dashboard.</span></center>
          <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
        </div>
      </div>
    </div>
  </div>

  </Layout>
</template>

<script>
import axios from "axios";
// import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { staffallowanceMethods, staffallowanceComputed, staffmemberMethods, staffmemberComputed } from "@/state/helpers";

export default {
  page: {
    title: "Staff Allowances",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Layout,PageHeader
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Staff Allowances",
      items: [ {text: "Dashboard",to: "/",}, {text: "Staff Allowances",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'id', label: 'ID', visible: false },
          { key: 'staffmember', label: 'Staff Member', visible: true },
          { key: 'amount', label: 'Amount', visible: true },
          { key: 'month', label: 'Month', visible: true },
          { key: 'year', label: 'Year', visible: true },
          { key: 'reason', label: 'Reason', visible: true },
          { key: 'addedon', label: 'Added On', visible: true },
          { key: 'actions', label: 'Actions', visible: true },
        ],
      id:'',
      staffmemberid:'',
      amount:'',
      month:new Date().getMonth()+1,
      year:new Date().getFullYear(),
      reason:'',
      fullname:'',
      btnuser:false,
    };
  },
  computed: {
    ...staffallowanceComputed,
    ...staffmemberComputed,
    List() { return this.staffallowances.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.staffallowances.map((d) => ({...d }))},
    IsBusy() { let a=false; if (this.staffallowances.length>0) { a=false;} else { a=true;} return a },
    totalallowances(){ var total = 0; this.staffallowances.forEach((item)=>{ var item_total = item.amount; total = Number(total)+Number(item_total);}); return total },
    years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = currentYear;
      const yearArray = [];
      for (let year = startYear; year <= endYear; year++) {  yearArray.push(year);  }
      return yearArray;
    },
  },
  mounted() {
    this.fetchStaffAllowances();
    this.fetchStaffMembers();
    this.TotalRows = this.staffallowances.length;
    this.isBusy=false;
  },
  methods: {
    ...staffallowanceMethods,
    ...staffmemberMethods,
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(id,staffmember,amount,month,year,reason){
      this.id=id;
      this.staffmemberid=staffmember;
      this.amount=amount;
      this.month=month;
      this.year=year;
      this.reason=reason;
      this.$bvModal.show('edit-allowance')
    },
    remove(id,fullname){
      this.id=id;
      this.fullname=fullname;
      this.$bvModal.show('delete-allowance')
    },
    async addAllowance() { 
      let formData = new FormData();
      formData.append("staffmemberid", this.staffmemberid);
      formData.append("amount", this.amount);
      formData.append("month", this.month);
      formData.append("year", this.year);
      formData.append("reason", this.reason);
      let url = "/addstaffallowance";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
          this.fetchStaffAllowances();
          this.$bvModal.hide('new-allowance');
          this.staffmemberid="";
          this.amount="";
          this.month="";
          this.reason="";
      }
      });
    },
    async editAllowance(){ 
    let formData = new FormData();
    formData.append("id", this.id);
    formData.append("staffmemberid", this.staffmemberid);
    formData.append("amount", this.amount);
    formData.append("month", this.month);
    formData.append("year", this.year);
    formData.append("reason", this.reason);
    let url = "/updatestaffallowance";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchStaffAllowances();
        this.$bvModal.hide('edit-allowance');
        this.staffmemberid="";
        this.amount="";
        this.month="";
        this.reason="";
      }
    });
    },
    async removeAllowance() { 
    let formData = new FormData();
    formData.append("id", this.id);
    let url = "/removestaffallowance";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchStaffAllowances();
        this.$bvModal.hide('delete-allowance');
      }
    });
    },
  },
};
</script>